import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class BusinessSettingsModel {
    static fromDTO(dto) {
        var _dto_templateVariables, _dto_defaultReferenceFields;
        return new BusinessSettingsModel(dto.legalTermsDocumentId, dto.disablePlaidLink, dto.netTerms, dto.billingDayOfMonth, dto.billingDayOfWeek, dto.billingScheduleDisplay, dto.feeControls, dto.amendmentsApprovalMethod, dto.invoicesApprovalMethod, dto.billUpfront, dto.automaticServicesPausedByDefault, dto.prorateFirstInvoice, dto.requestAccountantAccess, dto.introductoryMessages, dto.startBillingOn, dto.invoiceLineItems, dto.invoiceLineItemDescription, dto.invoiceLineItemPeriod, dto.expirationDate, dto.invoicePrefix, (_dto_templateVariables = dto.templateVariables) !== null && _dto_templateVariables !== void 0 ? _dto_templateVariables : [], (_dto_defaultReferenceFields = dto.defaultReferenceFields) !== null && _dto_defaultReferenceFields !== void 0 ? _dto_defaultReferenceFields : []);
    }
    constructor(legalTermsDocumentId, disablePlaidLink, netTerms, billingDayOfMonth, billingDayOfWeek, billingScheduleDisplay, feeControls, amendmentsApprovalMethod, invoicesApprovalMethod, billUpfront, automaticServicesPausedByDefault, prorateFirstInvoice, requestAccountantAccess, introductoryMessages, startBillingOn, invoiceLineItems, invoiceLineItemDescription, invoiceLineItemPeriod, expirationDate, invoicePrefix, templateVariables, defaultReferenceFields){
        _define_property(this, "legalTermsDocumentId", void 0);
        _define_property(this, "disablePlaidLink", void 0);
        _define_property(this, "netTerms", void 0);
        _define_property(this, "billingDayOfMonth", void 0);
        _define_property(this, "billingDayOfWeek", void 0);
        _define_property(this, "billingScheduleDisplay", void 0);
        _define_property(this, "feeControls", void 0);
        _define_property(this, "amendmentsApprovalMethod", void 0);
        _define_property(this, "invoicesApprovalMethod", void 0);
        _define_property(this, "billUpfront", void 0);
        _define_property(this, "automaticServicesPausedByDefault", void 0);
        _define_property(this, "prorateFirstInvoice", void 0);
        _define_property(this, "requestAccountantAccess", void 0);
        _define_property(this, "introductoryMessages", void 0);
        _define_property(this, "startBillingOn", void 0);
        _define_property(this, "invoiceLineItems", void 0);
        _define_property(this, "invoiceLineItemDescription", void 0);
        _define_property(this, "invoiceLineItemPeriod", void 0);
        _define_property(this, "expirationDate", void 0);
        _define_property(this, "invoicePrefix", void 0);
        _define_property(this, "templateVariables", void 0);
        _define_property(this, "defaultReferenceFields", void 0);
        this.legalTermsDocumentId = legalTermsDocumentId;
        this.disablePlaidLink = disablePlaidLink;
        this.netTerms = netTerms;
        this.billingDayOfMonth = billingDayOfMonth;
        this.billingDayOfWeek = billingDayOfWeek;
        this.billingScheduleDisplay = billingScheduleDisplay;
        this.feeControls = feeControls;
        this.amendmentsApprovalMethod = amendmentsApprovalMethod;
        this.invoicesApprovalMethod = invoicesApprovalMethod;
        this.billUpfront = billUpfront;
        this.automaticServicesPausedByDefault = automaticServicesPausedByDefault;
        this.prorateFirstInvoice = prorateFirstInvoice;
        this.requestAccountantAccess = requestAccountantAccess;
        this.introductoryMessages = introductoryMessages;
        this.startBillingOn = startBillingOn;
        this.invoiceLineItems = invoiceLineItems;
        this.invoiceLineItemDescription = invoiceLineItemDescription;
        this.invoiceLineItemPeriod = invoiceLineItemPeriod;
        this.expirationDate = expirationDate;
        this.invoicePrefix = invoicePrefix;
        this.templateVariables = templateVariables;
        this.defaultReferenceFields = defaultReferenceFields;
    }
}
